/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

// redux utils
import {createSlice} from '@reduxjs/toolkit';
// thunks
import {fetchAccountSSOconfig, updateAccountSSOconfig} from "../../thunks/settings/companySettings";


/* ========== ~~~~~~~~~~ ACCOUNT SLICE : REDUCER ~~~~~~~~~~ ========== */
const initialState = {
    authentication: {
        uuid: '',
        requestStatus: 'idle',
        isSocialSsoEnabled: false,
        isCustomSsoEnabled: false,
        allowAccountCreationForOnlyCommenting: false,
        customSsoSecretKey: "",
        ssoOptions: []
    }
};
export const companySettingsSlice = createSlice({
    name: 'companySettings',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        builder
            // get authentication settings
            .addCase(fetchAccountSSOconfig.rejected, (state, action) => {
                state.authentication.requestStatus = 'rejected'
            })
            .addCase(fetchAccountSSOconfig.pending, (state, action) => {
                state.authentication.requestStatus = 'pending'
            })
            .addCase(fetchAccountSSOconfig.fulfilled, (state, action) => {
                state.authentication = {requestStatus: 'idle', ...action.payload}
            })
            // update authentication settings
            .addCase(updateAccountSSOconfig.rejected, (state, action) => {
                state.authentication.requestStatus = 'rejected'
            })
            .addCase(updateAccountSSOconfig.pending, (state, action) => {
                state.authentication.requestStatus = 'pending'
            })
            .addCase(updateAccountSSOconfig.fulfilled, (state, action) => {
                state.authentication = {requestStatus: 'idle', ...action.payload}
            })
    }
});

// export const { setUserIP, setSessionData, storeSessionData } = accountSlice.actions;
export default companySettingsSlice.reducer;
